import { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { api } from "../lib/api";
import Footer from "../components/Footer";

const VALID_SLUGS = ["privacy", "shipping", "returns", "terms"];

export default function PolicyPage() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\/+/, "").split("/")[0];
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    if (!VALID_SLUGS.includes(slug)) return;
    api.get(`/policies/${slug}`).then((r) => setPolicy(r.data)).catch(() => setPolicy({ title: "", content: "" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  useEffect(() => {
    if (policy?.meta_title) document.title = policy.meta_title;
    if (policy?.meta_description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = "description";
        document.head.appendChild(tag);
      }
      tag.content = policy.meta_description;
    }
  }, [policy]);

  if (!VALID_SLUGS.includes(slug)) {
    return <Navigate to="/" replace />;
  }

  return (
    <main data-testid={`policy-page-${slug}`} className="bg-[#0A0A0A] min-h-screen pt-[100px] pb-20">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-[11px] tracking-[0.45em] uppercase text-[#D4AF37] mb-3">
          ✦ Studio
        </div>
        <h1 className="font-serif-display text-5xl md:text-6xl tracking-tight" style={{ color: "#FFFFFF" }}>
          {policy?.title || "—"}
        </h1>
        {policy?.updated_at && (
          <p className="mt-3 font-body" style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", letterSpacing: "0.1em" }}>
            Last updated · {new Date(policy.updated_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}
          </p>
        )}
        <div
          data-testid="policy-content"
          className="prose prose-invert max-w-none mt-10"
          style={{ color: "rgba(255,255,255,0.85)" }}
          dangerouslySetInnerHTML={{ __html: policy?.content || "<p style='color:rgba(255,255,255,0.5);font-style:italic;'>This page is being updated. Please check back soon.</p>" }}
        />
      </div>
      <Footer />
    </main>
  );
}
